<template lang="html">
  <header class="navbar sticky-top navbar-expand-lg bg-white navbar-light mx-auto py-1">
    <router-link class="navbar-brand pull-left brand expanded"
                 :to="{ name: 'home' }"
                 @click.native="checkIfHome">
    </router-link>
    <a
      @click="handleOpenSideMenu"
      class="px-1 navbar-brand pull-left brand collapsed d-lg-none"
      aria-label="Categorías"
      href="#side-menu">
      <span class="navbar-toggler-icon"></span>
    </a>
    <div class="d-flex d-lg-none centered-brand" @click="goHome"></div>
    <Search class="d-none d-lg-flex" id="searchBox1"/>
    <div class="d-flex d-lg-none">
      <Search id="searchBox2"/>
      <button
        @click="toggleCover"
        class="navbar-toggler mr-1 p-0"
        type="button"
        data-toggle="collapse"
        data-target="#mobileMenu"
        aria-controls="mobileMenu"
        aria-expanded="false"
        aria-label="Toggle navigation">
          <font-awesome-icon class="menu-icon d-lg-none" :icon="[ 'fas', 'user' ]" />
        <NotificationSign :active="isAuth && unseenNotifications"/>
      </button>
    </div>
    <nav class="collapse navbar-collapse ml-0" id="mobileMenu">
      <ul class="navbar-nav navbar-right ml-auto">

        <Notifications v-if="isAuth" @click="handleClose" />

        <MarketplaceMenu v-if="mktTest" @close="handleClose" />

        <AccountMenu v-if="isAuth" @close="handleClose" />

        <li v-else class="nav-item" data-toggle='collapse' data-target="#mobileMenu" >
          <a @click="handleClose" class="nav-link mt-1" href="#" data-toggle="modal" data-target="#loginModal" >
            Ingresá
          </a>
        </li>

        <li class="nav-item" data-toggle="collapse" data-target="#mobileMenu" >

          <a  @click.prevent="goSell" class="nav-link mt-1" href="#" :data-toggle="`${isAuth ? '' : 'modal'}`" data-target="#loginModal" >
            <font-awesome-icon class="menu-icon d-md-none" :icon="[ 'fas', 'dollar-sign' ]" />
            Publicar
          </a>
        </li>

        <li class="nav-item dropdown">
          <a
            class="nav-link mt-1" href="#"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <font-awesome-icon class="menu-icon d-lg-none" :icon="[ 'fas', 'question-circle' ]" />
            Ayuda
          </a>
          <ul
            @click="handleClose"
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdownMenuButton">
            <a
              class="dropdown-item py-2" href="https://conocenos.maspocovendo.com">
              <span class="badge badge-danger">NUEVO</span>
              Servicios para empresas
            </a>
            <router-link
              data-toggle="collapse"
              data-target="#dropdownMenuButton"
              class="dropdown-item py-2"
              :to="{ name: 'faq' }">
              Preguntas frecuentes
            </router-link>
            <router-link
              data-toggle="collapse"
              data-target="#dropdownMenuButton"
              class="dropdown-item py-2"
              :to="{ name: 'privacy' }">
              Política de privacidad
            </router-link>
            <router-link
              data-toggle="collapse"
              data-target="#dropdownMenuButton"
              class="dropdown-item py-2"
              :to="{ name: 'contact' }">
              Contactanos
            </router-link>
            <a
              href="https://wa.me/5493492207296"
              target="_blank"
              rel="noopener"
              class="dropdown-item py-2 d-flex align-items-center">
              Conversá con Mía
              <span class="wa-bubble-sm ml-2">
                <font-awesome-icon :icon="[ 'fab', 'whatsapp' ]" />
              </span>
            </a>
          </ul>
        </li>

      </ul>
    </nav>
  </header>
</template>

<script>
import Search from './TheNavbarSearch'
import AccountMenu from '@/components/layout/TheNavbarAccountMenu'
import MarketplaceMenu from '@/components/layout/TheMarketplaceMenu'
import Notifications from '@/components/user/Notifications'
import store from '@/store'
import $ from 'jquery'
import { instance as componentDialog } from '@/components/layout/ComponentDialog'
import { instance as actionDialog } from '@/components/layout/ActionDialog'
import AddEmail from '@/components/user/AddEmail'
import AddPhone from '@/components/user/AddPhone'

export default {
  components: {
    Search,
    AccountMenu,
    Notifications,
    MarketplaceMenu
  },

  computed: {

    mktTest: () => store.state.user.isAuth && [1,2,3].includes(store.state.user.id),

    isAuth: () => store.state.user.isAuth || false,

    notifications: () => store.state.user.notifications,

    notificationsCheckpoint: () => store.state.user.notificationsCheckpoint,

    unseenNotifications () {
      return this.notificationsCheckpoint && this.notifications.filter(n => Date.parse(n.date) > Date.parse(this.notificationsCheckpoint)).length > 0
    },

    mainEmail: () => store.state.user.emails.filter(e => e.email === store.state.user.email)[0],

    phones: () => store.state.user.phones,

    hasVerifiedPhone () { return this.phones.filter(p => p.verified).length > 0 },

    name: () => store.getters['user/name'],

    canSell () { return this.mainEmail && this.mainEmail.verified && this.hasVerifiedPhone && this.name },

    isInProfile () { return this.$route.name === 'userProfile' },

  },

  methods: {
    goSell () {
      this.pushToDataLayer('Header', 'Sell')
      this.handleClose()
      if (this.isAuth) {
        if (this.canSell)
          this.$router.push({name: 'sell', params: {step: 'categoria'}})
        else
          this.checkRequiredUserInfo()
      }
    },

    goHome () {
      this.handleClose()
      this.$router.push({name: 'home'},
        () => {},
        () => {
          store.dispatch('setRefreshHome', true)
          window.scrollTo(0, 0)
      })
    },

    checkIfHome () {
      if (this.$route.name === 'home') {
        store.dispatch('setRefreshHome', true)
        window.scrollTo(0, 0)
      }
    },

    handleClose () {
      $('#mobileMenu').collapse('hide')
      this.uncover()
    },

    handleOpenSideMenu () {
      this.pushToDataLayer('Header', 'Categories menu open')
      // Close mobile menu and uncover
      this.handleClose()
    },

    toggleCover () {
      if ($('#mobileMenu')[0].className.includes('show')) {
        // Close menu, hides cover
        dispatchEvent(new Event('uncover'))
      } else {
        // Open menu, show cover
        dispatchEvent(new Event('cover'))
        this.pushToDataLayer('Navbar', 'User menu open')
      }
    },

    cover () { dispatchEvent(new Event('cover')) },

    uncover () { dispatchEvent(new Event('uncover')) },

    checkRequiredUserInfo () {
      if ((!this.mainEmail || this.mainEmail && !this.mainEmail.verified) && !this.hasVerifiedPhone && !this.name) {
        actionDialog({
          statement: 'Para poder publicar en nuestro sitio, necesitás agregar un nombre, un correo electrónico y un teléfono móvil (y verificarlos) en tu perfil de usuario',
          positiveLabel: this.isInProfile ? 'Aceptar' : 'Ir al perfil',
          positiveAction: () => { this.$router.push({ name: 'userProfile' }) },
        })
      } else if (this.mainEmail && !this.mainEmail.verified) {
        componentDialog({
          component: AddEmail,
          header: 'Verificá tu email para poder vender',
          noClose: true,
          props: {
            action: 'MAIN',
            email: this.mainEmail.email
          }
        })
      } else if (!this.mainEmail) {
        componentDialog({
          component: AddEmail,
          header: 'Agregá un email para poder vender',
          noClose: true,
          props: {
            action: 'FIRST'
          },
          then: !this.isInProfile ?
            () => { this.$router.push({ name: 'userProfile' }) } :
            undefined
        })
      } else if (!this.hasVerifiedPhone) {
        componentDialog({
          component: AddPhone,
          header: 'Agrega un nuevo teléfono',
          props: {
            action: 'FIRST'
          },
          then: () => {
            this.$router.push({ name: 'sell', params: { step: 'categoria' } })
          }
        })
      } else if (!this.name) {
        actionDialog({
          statement: 'Para poder publicar en nuestro sitio, necesitás agregar un nombre en tu perfil de usuario',
          positiveLabel: this.isInProfile ? 'Aceptar' : 'Ir al perfil',
          positiveAction: () => { this.$router.push({ name: 'userProfile' }) },
        })
      }
    }
  },

  mounted () {
    addEventListener('click', e => {
      if (String(e.target.className).includes('cover-default'))
        this.handleClose()
    })
  },

  watch: {
    $route (from, to) {
      // On any route change
      // 1- Blur the active element and try to uncover the opaque backdrop to prevent the navbar
      // from remaining active when going back with the browser
      document.activeElement.blur()
      this.uncover()
      // 2- Hide any opened modal
      $('.modal').modal('hide')
    }
  },
}
</script>

<style lang="scss">
  @import '../../scss/globals';
  @import '../../scss/aspect';
  @import '../../scss/colors';
  @import '../../scss/breakpoints';

  /* clears the 'X' from Internet Explorer */
  input[type=search]::-ms-clear {  display: none; width : 0; height: 0; }
  input[type=search]::-ms-reveal {  display: none; width : 0; height: 0; }

  /* clears the 'X' from Chrome */
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration { display: none; }


  .centered-brand {
    height: 1.5rem;
    flex-grow: 1;
    background-image: url($CDN_STATIC + '/static/img/logo.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    cursor: pointer;
  }

  .navbar {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    position: fixed;
    z-index: 1050;
    width: 100%;
    min-height: $navbar-height;
    padding-left:  calc(50% - (#{$max-width} / 2));
    padding-right: calc(50% - (#{$max-width} / 2));

    &-collapse {
      width: 22rem;
      font-weight: bolder;
      font-size: 1rem;
    }

    &-toggler {
      max-width: 10%;
      min-width: 2rem;
      position: relative;
      border: none;
    }

    &-brand {
      width: 12rem;
      max-width: 100%;
      margin: 0 0.25rem 0 0.5rem;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 50%;
    }

    & .navbar-nav {
      & .dropdown-menu {
        margin: 0;
      }
      & .nav-link {
        color: #6E7881;
      }
      li:last-child{
        border-bottom: none;
      }
    }
  }

  @media screen and (max-width: map-get($grid-breakpoints, "md")) {
    .navbar-brand {
      width: 40px;
      height: 40px;
      margin-right: 0 !important;
    }
  }

  @media screen and (min-width: map-get($grid-breakpoints, "md")) {
    .navbar-brand {
      background-image: url($CDN_STATIC + '/static/img/logo.png');
      width: 220px;
      height: 40px;
      padding: 0;
    }
  }

  @media screen and (min-width: map-get($grid-breakpoints, "lg")) {
    .navbar {
      &-brand.collapsed {
        display: none;
      }

      &-brand.expanded {
        display: block;
      }

      &-collapse {
        flex-grow: 0;
      }
    }
  }

  .navbar-collapse ul > li {
    text-align: center;
  }

  .navbar-collapse.show ul > li {
    border-bottom: solid 1px $gray-400;

    &:hover {
      background-color: $gray-400;
    }
  }

  i.fa {
    width: 2rem;
    color: $primary;
    font-size: 1.5rem;
  }

  .menu-icon{
    font-size: 1.5rem;
    padding-top: 5px;
  }

  .btn-outline-primary {
    border-color: $gray-400;

    &:hover {
      background-color: $light;
    }
  }

  // expand the form width to 100% and hide sibblings
  @media screen and (max-width: map-get($grid-breakpoints, "lg")) {
    .atlwdg-popup {
      max-width: 355px !important;
    }

    .navbar-toggler-icon {
      vertical-align: top !important;
    }

    .navbar-brand {
      max-width: 38px;
      background-image: none !important;

        &.collapsed {
          display: block;
        }

        &.expanded {
          display: none;
        }
    }

    .dropdown-item {
      font-size: 1.125rem;
    }
  }

  .wa-bubble-sm {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50% 50% 50% 2px;
    background-color: #25D366;
    color: #fff;
    font-size: 0.8rem;
    margin-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/TheNavbar.vue